import * as constants from '../constants';

/* eslint-disable import/prefer-default-export */
export const initializeBasicInfo = ({
  data,
  isLoaded,
  hasRegisteredChanges,
}) => (dispatch) =>
  dispatch({
    type: constants.SET_INITIAL_BASIC_INFO_STATE,
    payload: { data, isLoaded, hasRegisteredChanges },
  });

export const setBasicInfoIsLoaded =
  (isLoaded) =>
    (dispatch) =>
      dispatch({
        type: constants.SET_BASIC_INFO_LOADED_STATE,
        payload: { isLoaded },
      });

export const updateBasicInfo = ({
  category,
  fieldName,
  value,
  hasRegisteredChanges,
}) => (dispatch) =>
  dispatch({
    type: constants.UPDATE_BASIC_INFO_FIELD_DATA,
    payload: {
      category,
      fieldName,
      value,
      hasRegisteredChanges,
    },
  });

export const addBasicInfoFieldData = ({
  fieldName,
  value,
  fieldKey,
}) => (dispatch) =>
  dispatch({
    type: constants.ADD_BASIC_INFO_FIELD_DATA,
    payload: {
      fieldName,
      value,
      fieldKey,
    },
  });

export const removeBasicInfoFieldData = ({
  fieldName,
  order,
}) => (dispatch) =>
  dispatch({
    type: constants.REMOVE_BASIC_INFO_FIELD_DATA,
    payload: {
      fieldName,
      order,
    },
  });

export const updateBasicInfoOptions = ({
  fieldName,
  value,
}) => (dispatch) =>
  dispatch({
    type: constants.UPDATE_BASIC_INFO_OPTIONS,
    payload: {
      fieldName,
      value,
    },
  });

export const setBasicInfoIsInvalid =
  (isInvalid) =>
    (dispatch) =>
      dispatch({
        type: constants.SET_BASIC_INFO_IS_INVALID,
        payload: { isInvalid },
      });

export const resetBasicInfo = () => (dispatch) =>
  dispatch({
    type: constants.RESET_BASIC_INFO,
  });
